import { mapToValueOrNull } from "./mapToValueOrNull";

export const mapToDateOrNull = <T>(value: T): string | NonNullable<T> | null => {
  const date = mapToValueOrNull(value);
  return typeof date === "string" && date ? new Date(date).toISOString().split("T")[0] : date;
};

// Return example: "2023-03-03" ; if includeTime: "2023-03-03T21:08:31.906Z"
export const convertDateToString = (date: Date, includeTime?: boolean): string => {
  try {
    const formattedDate = new Date(date).toISOString();
    return includeTime ? formattedDate : formattedDate.split("T")[0];
  } catch (error) {
    // Return current date in case of error.
    const currentDate = new Date().toISOString();
    return includeTime ? currentDate : currentDate.split("T")[0];
  }
};
